module.exports = __webpack_public_path__ + "images/patterns/light/StripeHorizontal.f337588386c0c0650d4e.svg";